<script setup lang="ts">
import { ref } from "vue";
import VideoModal from "@/ts/components/elements/video-modal.vue";
import UniversalVideo from "@/ts/components/elements/universal-video.vue";

let show = ref(false);

const modal = ref({ open: false });

interface Props {
    videoUrl: string;
    subtitle: string;
}

defineProps<Props>();
</script>

<template>
    <transition name="fade" appear>
        <div @click.prevent="modal.open = true" class="flex group cursor-pointer flex-col z-[9999] absolute inset-0 w-full h-full items-center justify-center">
            <div class="inset-0 w-full h-full absolute bg-primary opacity-75"></div>
            <div class="flex flex-col p-5 z-10 items-center justify-center gap-4">
                <p class="text-white text-center text-h5" v-if="subtitle" v-html="subtitle"></p>
                <button title="video afspelen"  class="drop-shadow text-primary group-hover:drop-shadow-lg group-hover:scale-110 group-hover:bg-gray-200 flex items-center justify-center w-[3.75rem] h-[3.75rem] md:w-20 md:h-20 transition-all bg-white rounded-full">
                    <svg class="md:w-5 w-4 h-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <path fill="currentColor" d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z" />
                    </svg>
                </button>
            </div>
        </div>
    </transition>
    <video-modal ref="modal">
        <universal-video :video-url="videoUrl"></universal-video>
    </video-modal>
</template>

<style lang="scss" scoped></style>
